import * as React from 'react';
const Check = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 15 13"
		fill="none"
		{...props}
	>
		<path
			fill="#FFF7F7"
			d="M4.75 12.315.093 7.658l2.122-2.123L4.75 8.078 12.16.66l2.123 2.123-9.533 9.532Z"
		/>
	</svg>
);
export default Check;
